module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-steps",
    class: ['is-' + _vm.direction]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-215252ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/src/steps.vue
// module id = 623
// module chunks = 0